import React from 'react'
import { Text } from '@chakra-ui/react'

import { Card, FieldList, FieldListItem } from 'components'

const formatDate = date => (date ? new Date(date).toLocaleString() : '')

export const ReportFormIDCard = ({ loading, report, auth, ...props }) => (
  <Card {...props} heading='Dados do Questionário'>
    <FieldList isLoading={loading}>
      <FieldListItem label='Data'>
        <Text>{formatDate(report?.dateCreated)}</Text>
      </FieldListItem>
      <FieldListItem label='Nome'>
        <Text>{report?.form?.name}</Text>
      </FieldListItem>
      {auth?.name && (
        <FieldListItem label='Utilizador'>
          <Text>{auth?.name}</Text>
        </FieldListItem>
      )}
    </FieldList>
  </Card>
)

export default ReportFormIDCard
